import { useRoutes, useNavigate } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import { useEffect } from 'react';
import ChangePasswordPage from 'pages/ChangePasswordPage';
import DeeplinkHandler from 'pages/DeeplinkHandler';

// ==============================|| ROUTING RENDER ||============================== //
function RootRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Skip redirect if we're on a deeplink route or invite route
    if (window.location.pathname.includes('integrations/deeplink') || 
        window.location.pathname.includes('/invite')) {
      return;
    }

    // Example: Check if the user is logged in by checking a session token
    const orgName = localStorage.getItem('org_name'); // Or wherever you store your session token

    if (orgName) {
      navigate(`/${orgName}/device-info`);
    } else {
      // Redirect to a generic login page if no business is found
      navigate('/allwell/login');
    }
  }, [navigate]);
  return null;
}

export default function ThemeRoutes() {
  return useRoutes([
    MainRoutes,
    LoginRoutes,
    { path: '/:organizationName/change-password', element: <ChangePasswordPage /> },
    {
      path: '*',
      // element: <Navigate to='/allwell/login' replace={true} />
      element: <RootRedirect />
    }
  ]);
}
